<template>
  <v-container fluid pa-0 p-t grid-list id="top-banner">
    <v-layout>
      <v-flex>
        <client-only>
          <GptAd
            v-if="!isLoading"
            :ad-unit="dfpToShow.adunit"
            :is-responsive="true"
            :size="dfpToShow.dfpSize"
          />
        </client-only>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  components: {},
  props: {
    isHitech: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isMobile: null,
      generalDFP: {
        adunit: '3177829/DRUSHIM_ANAKNEW_1260',
        dfpSize: '1260x100',
        id: '1564407251297',
      },
      generalMobileDFP: {
        adunit: '3177829/NEW_mobile_strip_top_banner_320',
        dfpSize: '320x50',
        id: '1582034260852-0',
      },
      hitechDFP: {
        adunit: '3177829/DRUSHIM_HITECH_ANAK-NEW_1260_TEST',
        dfpSize: '1260x100',
        id: '1582019636699-0',
      },
      hightecMobileDFP: {
        adunit: '3177829/new_mobile_strip_top_banner_hitech',
        dfpSize: '320x50',
        id: '1603105645514-0',
      },
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 750
  },
  computed: {
    dfpToShow() {
      if (this.isHitech) {
        return this.isMobile ? this.hightecMobileDFP : this.hitechDFP
      } else {
        return this.isMobile ? this.generalMobileDFP : this.generalDFP
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#top-banner {
  background: #f5f5f5;
  text-align: center;
}
</style>
